function IconKebap() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 22 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="11" fill="#929292" />
      <circle cx="11" cy="52" r="11" fill="#929292" />
      <circle cx="11" cy="93" r="11" fill="#929292" />
    </svg>
  );
}

export default IconKebap;
